import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    ModalBody,
    Input,
    Label,
    FormGroup,
    Form,
} from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const BroadcastAddEditModal = ({
    setBroadcastAddEditModalOpen,
    broadcastAddEditModalOpen,
}) => {
    const roundToNextQuarter = (date) => {
        const d = new Date(date);
        const minutes = d.getMinutes();

        // Calculate next quarter (0, 15, 30, 45)
        const nextQuarter = Math.ceil(minutes / 15) * 15;

        if (nextQuarter === 60) {
            d.setHours(d.getHours() + 1);
            d.setMinutes(0);
        } else {
            d.setMinutes(nextQuarter);
        }

        d.setSeconds(0);
        return d;
    };


    const [formData, setFormData] = useState({
        name: "",
        sendTo: [],
        quota: "active",
        schedule: null,
        message: "",
        send_to: "",
    });

    useEffect(() => {
        const now = new Date();
        const rounded = roundToNextQuarter(now);
        setFormData((prev) => ({ ...prev, schedule: rounded }));
    }, []);

    const sendToOptions = [
        { label: "Candidate", value: "candidate" },
        { label: "Client", value: "client" },
        { label: "Caller", value: "caller" },
        { label: "Team Lead", value: "team_lead" },
        { label: "Account Executive", value: "account_executive" },
        { label: "Manager", value: "manager" },
        { label: "Admin", value: "admin" },
    ];

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log("Form Data:", formData);
    };

    const closeModal = () => setBroadcastAddEditModalOpen(false);

    return (
        <Modal
            isOpen={broadcastAddEditModalOpen}
            toggle={closeModal}
            backdrop="static"
            className="modal-full-height"
            centered
        >
            <ModalBody className="p-4 modal-height-fixed">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="fw-bold mb-0">Broadcast Notification</h5>
                    <Button close onClick={closeModal} />
                </div>
                <hr />

                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label>Incentive Type</Label>
                        <Input
                            type="select"
                            name="send_to"
                            value={formData.send_to}
                            onChange={handleChange}
                            className="w-100"
                        >
                            <option value="">Select</option>
                            <option value="all">All</option>
                            <option value="staffs">Staffs</option>
                            <option value="team_leads">Team Leads</option>
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label>Schedule *</Label>
                        <div className="schedule-move">
                            <DatePicker
                                selected={formData.schedule}  // will select the rounded time correctly
                                onChange={(date) =>
                                    setFormData({ ...formData, schedule: roundToNextQuarter(date) })
                                }
                                showTimeSelect
                                timeIntervals={15}            // ⭐ needed to show your rounded time
                                dateFormat="MMMM d, yyyy h:mm aa"
                                className="form-control w-100"
                                placeholderText="Select date & time"
                                popperPlacement="bottom"
                                inline
                            />

                        </div>
                    </FormGroup>

                    <FormGroup>
                        <Label>Message *</Label>
                        <Input
                            type="textarea"
                            name="message"
                            rows="4"
                            placeholder="Enter message"
                            value={formData.message}
                            onChange={handleChange}
                            className="w-100"
                        />
                    </FormGroup>

                    <div className="text-end mt-3">
                        <Button color="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default BroadcastAddEditModal;
